import * as React from 'react';
import Svg, { Path } from 'react-native-svg';

import { ds } from '@/components/lib/design.system';

export const CheckmarkPlayerStats = props => (
    <Svg xmlns="http://www.w3.org/2000/svg" width={17} height={16} fill="none" {...props}>
        <Path
            stroke={props.color ?? ds.colorValue.icon.success}
            strokeLinecap="round"
            strokeWidth={1.5}
            d="m4.58 8.08 2.541 2.54c.26.26.683.26.943 0l5.218-5.218"
        />
    </Svg>
);
